<template>
  <div class="objects-select-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <select class="form-control" multiple ref="dropdown"
          @change="validate()"
          :name="options.name+'[]'">
          <option 
            v-for="object in options.objects" 
            :value="object.uuid || object.value" 
            :key="object.uuid">
            {{ object[options.objectName] }}
          </option>
        </select>
          <span :class="validationClass" v-show="validationMessage">
            {{ validationMessage }}
          </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Choices from 'choices.js'
  import Api from '@/vuex/api'
  import dom from '@/util/dom'
  import {
    validationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'ObjectsSelectInput',
    props: {
      value: {
        type: [Array, String]
      },
      options: {
        type: Object,
        default () {
          return {
            label: 'Text',
            name: 'objectsSelect',
            allowNew: false,
            objectName: 'name',
            value: [],
            objects: []
          }
        }
      }
    },
    computed: {
      validationClass,
      validationMessage,
      invalidMessage () {
        return this.options.label + ' is required'
      }
    },
    data () {
      return {
        isDirty: false,
        isValid: false,
        choices: null,
        existingValues: []
      }
    },
    mounted () {
      this.existingValues = this.options.existing || []
      let $vm = this
      this.choices = new Choices(this.$refs.dropdown, {
        itemSelectText: '',
        removeItemButton: true,
        searchFields: ['label'],
        fuseOptions: {
          threshold: 0.1
        },
        callbackOnInit: function () {
          this.containerInner.id = $vm.options.name
          if (!$vm.value) {
            let value = this.store.getItemsFilteredByActive().pop().value
            this.removeItemsByValue(value)
          } else {
            this.setValueByChoice($vm.value)
          }
        }
      })
    },
    watch: {
      'options.objects': function (oldVal, newVal) {
        this.updateChoices()
      }
    },
    methods: {
      async updateChoices () {
        if (this.choices) {
          // updates the choices input with new values
          this.choices.clearInput()
          this.choices.config.searchPlaceholderValue = 'Select a ' + this.options.label
          this.choices.config.placeholderValue = 'Select a ' + this.options.label
          if (this.choices.containerInner.children[1].children[0]) {
            this.choices.containerInner.children[1].children[0].innerHTML = ''
          }
          this.choices.containerOuter.children[1].children[0].placeholder = 'Select a ' + this.options.label
          this.choices.setChoices(this.options.objects, 'uuid', this.options.objectName, true)
          await this.$nextTick()
          if (this.value) {
            this.choices.removeHighlightedItems()
            this.choices.removeActiveItems()
            this.choices.setValueByChoice(this.value)
          }
        }
      },
      async validate () {
        await this.$nextTick()
        let val = this.choices.getValue(true)
        this.$emit('input', val)
        if (val.length > 0) {
          this.isDirty = true
          if (this.options.required) {
            this.isValid = val ? val.length > 0 : true
          } else {
            this.isValid = true
          }
        } else if (this.options.required) {
          this.isDirty = true
          this.isValid = false
        } else {
          this.isValid = true
        }
        let choicesInner = document.getElementById(this.options.name)
        if (this.isValid) {
          if (dom(choicesInner).hasClass('is-invalid')) {
            dom(choicesInner).removeClass('is-invalid')
          }
          if (!dom(choicesInner).hasClass('is-valid')) {
            dom(choicesInner).addClass('is-valid')
          }
        } else {
          if (dom(choicesInner).hasClass('is-valid')) {
            dom(choicesInner).removeClass('is-valid')
          }
          if (!dom(choicesInner).hasClass('is-invalid')) {
            dom(choicesInner).addClass('is-invalid')
          }
        }
      },
      runWatcher (val, name) {
        switch (name) {
          case 'companyName':
            this.getManagers(val)
            break
        }
      },
      async getManagers (val) {
        let instance = new Api()
        let company = await instance.getCompany(val)
        if (company && company.Accounts.length) {
          company.Accounts.map(function (val, i) {
            company.Accounts[i] = { value: val.email, label: val.dropdownLabel }
          })
          this.resetChoices(company.Accounts)
        } else {
          this.resetChoices()
        }
      },
      resetChoices (options = this.existingValues) {
        let val = this.value || []
        if (this.choices) {
          let found = options.find(el => val.includes(el.value))
          this.choices.setChoices(options, 'value', 'label', true)
          this.choices.removeHighlightedItems()
          this.choices.removeActiveItems()
          if (val.length && found) {
            this.choices.setValueByChoice(this.value)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/ObjectsSelectInput.vue